const baseApiUrl = 'https://api-staging.casa-doc.it';
const apiUrl = `${baseApiUrl}/api`;

export const environment = {
  production: false,
  appName: 'casa-doc-ai',
  baseApiUrl,
  apiUrl,
};
